import React from 'react'
import MaterialSymbol from '../material-symbol'

const LocationCity = React.forwardRef((props, ref) => (
  <MaterialSymbol ref={ref} name="location_city" {...props} />
))

LocationCity.displayName = 'LocationCity'

export default LocationCity
